import PropTypes from 'prop-types';

export const handler = PropTypes.func;
export const edit = PropTypes.bool;
export const pristine = PropTypes.bool;
export const submitting = PropTypes.bool;
export const valid = PropTypes.bool;
export const url = PropTypes.string;
export const router = PropTypes.object;
export const children = PropTypes.element;
export const title = PropTypes.string;
export const count = PropTypes.number;


export const category = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
});
export const categories = PropTypes.arrayOf(category);

export const brand = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
});
export const brands = PropTypes.arrayOf(brand);

export const product = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  desc: PropTypes.string,
  price: PropTypes.number.isRequired,
  inventory: PropTypes.number.isRequired,
  quantity: PropTypes.number,
  isRetail: PropTypes.bool,
});
export const products = PropTypes.arrayOf(product);

export const tax = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  percentage: PropTypes.number.isRequired,
  addToPrice: PropTypes.bool.isRequired,
  externalOrdersOnly: PropTypes.bool.isRequired,
  enabled: PropTypes.bool.isRequired,
});
export const taxes = PropTypes.arrayOf(tax);

export const childrenOrValue = PropTypes.oneOfType([children, PropTypes.number, PropTypes.string]);
